export enum SurveyCustomElementType {
    PHARMACY_FINDER = 'PHARMACY_FINDER',
    FLU_MIND_BENDER = 'FLU_MIND_BENDER',
    SUGGESTED_CARE = 'SUGGESTED_CARE'
}
